import { LoginErrors } from '@kudos/http-client'
import { isAxiosError } from 'axios'

export const isMfaRequiredForTenant = (error: unknown): boolean => {
  if (isAxiosError(error)) {
    const data = error.response?.data as LoginErrors | undefined
    return data?.error === 'MFARequiredForTenant'
  }
  return false
}
